import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import { Reveal, LineReveal } from "@/components/Reveal";

export default function Beliefs() {
  const { beliefs, settings } = useContent();
  const s = settings || {};

  return (
    <div data-testid="beliefs-page">
      <section className="border-b border-hairline/50 pt-40 pb-24 md:pt-52 md:pb-32">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10">
          <div className="text-xs uppercase tracking-[0.32em] text-kinetic">The Manifesto</div>
          <h1 className="mt-6 max-w-4xl font-display text-6xl font-bold leading-[0.9] tracking-tighter text-bone md:text-8xl">
            <LineReveal text={"Political\nBeliefs"} />
          </h1>
          <Reveal delay={0.4} className="mt-8 max-w-xl text-lg text-bone/70">
            <p>{s.beliefs_intro}</p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-5 md:px-10">
        {beliefs.map((b, i) => (
          <Reveal key={b.id}>
            <article
              data-testid={`belief-item-${i}`}
              className="grid items-start gap-8 border-b border-hairline/50 py-16 md:grid-cols-[0.5fr_1fr] md:gap-20 md:py-24"
            >
              <div className="font-display text-8xl font-bold leading-none tracking-tighter text-transparent md:text-[10rem]"
                   style={{ WebkitTextStroke: "1.5px #2A314A" }}>
                {b.number || String(i + 1).padStart(2, "0")}
              </div>
              <div className="md:pt-6">
                <h2 className="font-display text-4xl font-bold tracking-tight text-bone md:text-5xl">{b.title}</h2>
                <p className="mt-6 max-w-2xl whitespace-pre-line text-lg leading-relaxed text-bone/70">{b.body}</p>
                {b.detail && b.detail.trim() && (
                  <Link
                    to={`/beliefs/${b.id}`}
                    data-testid={`belief-readmore-${i}`}
                    className="link-underline mt-6 inline-flex items-center gap-2 text-sm uppercase tracking-widest text-kinetic"
                  >
                    Read more <ArrowRight size={15} />
                  </Link>
                )}
              </div>
            </article>
          </Reveal>
        ))}
        <div className="h-24" />
      </section>
    </div>
  );
}
